import { render, staticRenderFns } from "./confirmacion.vue?vue&type=template&id=6df4c492&scoped=true&"
import script from "./confirmacion.vue?vue&type=script&lang=js&"
export * from "./confirmacion.vue?vue&type=script&lang=js&"
import style0 from "./confirmacion.vue?vue&type=style&index=0&id=6df4c492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df4c492",
  null
  
)

export default component.exports